var _circle, _circle2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServiceCodeWarningIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.12,
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F9B803"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 20,
    cy: 20,
    r: 16,
    fill: "#F9B803"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9984 17.75V20.75M19.9984 23.75H20.0059M18.9598 13.9188L12.7912 24.5737C12.449 25.1647 12.2779 25.4602 12.3032 25.7028C12.3253 25.9143 12.4361 26.1065 12.6081 26.2316C12.8053 26.375 13.1468 26.375 13.8297 26.375H26.167C26.8499 26.375 27.1914 26.375 27.3886 26.2316C27.5606 26.1065 27.6714 25.9143 27.6935 25.7028C27.7188 25.4602 27.5477 25.1647 27.2055 24.5737L21.0369 13.9188C20.6959 13.3299 20.5255 13.0355 20.3031 12.9366C20.1091 12.8503 19.8876 12.8503 19.6936 12.9366C19.4712 13.0355 19.3008 13.3299 18.9598 13.9188Z",
    stroke: "#F9B803",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceCodeWarningIcon);
export default __webpack_public_path__ + "static/media/serviceCodeWarningIcon.b4ff775ecf41a0e3ca85f25fd565aa02.svg";
export { ForwardRef as ReactComponent };